var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'hammer-timejs';
import 'hammerjs';
import { ErrorHandler } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';
import * as Sentry from '@sentry/browser';
import { environment } from '../environments/environment';
import { AppConfig } from './app.config';
import { localisationFactory } from './services/localisation.service';
Sentry.init({
    dsn: AppConfig.sentryDsn,
    release: AppConfig.version
});
var SentryErrorHandler = /** @class */ (function () {
    function SentryErrorHandler() {
    }
    SentryErrorHandler.prototype.handleError = function (err) {
        Sentry.withScope(function (scope) {
            scope.setExtra('debug', false);
            Sentry.captureException(err.originalError || err);
        });
        if (!environment.production) {
            console.error(err);
        }
    };
    return SentryErrorHandler;
}());
export { SentryErrorHandler };
var MyHammerConfig = /** @class */ (function (_super) {
    __extends(MyHammerConfig, _super);
    function MyHammerConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overrides = {
            swipe: { velocity: 0.4, threshold: 20 },
            pinch: { enable: false },
            rotate: { enable: false }
        };
        return _this;
    }
    return MyHammerConfig;
}(HammerGestureConfig));
export { MyHammerConfig };
var ɵ0 = localisationFactory;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js